import { LogOut } from "lucide-react";
import { useEffect } from "react";

const SAFE_URL = "https://www.weather.com";

const quickExit = () => {
  // Replace current history entry so back button won't return here.
  try {
    window.location.replace(SAFE_URL);
  } catch {
    window.location.href = SAFE_URL;
  }
};

export default function QuickExit() {
  useEffect(() => {
    let last = 0;
    const onKey = (e) => {
      // Double-press Escape quickly (within 500ms) to exit — avoids accidental exits.
      if (e.key === "Escape") {
        const now = Date.now();
        if (now - last < 500) quickExit();
        last = now;
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  return (
    <button
      type="button"
      onClick={quickExit}
      data-testid="quick-exit-button"
      aria-label="Quick exit to a neutral website"
      className="fixed top-4 right-4 z-[70] inline-flex items-center gap-2 rounded-full bg-rust px-5 py-2.5 text-sm font-semibold text-white shadow-[0_8px_30px_rgba(45,48,42,0.18)] transition-transform duration-300 hover:scale-105 hover:bg-[#9c5344] focus:outline-none focus:ring-2 focus:ring-white/70"
    >
      <LogOut className="h-4 w-4" strokeWidth={2.4} />
      Quick exit
    </button>
  );
}
